// @flow
import { useQuery } from 'react-query';
import checkHouseholdMembersHaveSignedConsent from 'utils/checkHouseholdMembersHaveSignedConsent';
import useHouseholdMembersQuery from 'hooks/queries/useHouseholdMembersQuery';

const useHaveAllHouseholdMembersSignedConsentQuery = () => {
  const { data: householdMembers } = useHouseholdMembersQuery();

  return useQuery(
    [
      'haveAllHouseholdMembersSignedConsentQuery',
      householdMembers?.map(({ id }) => id),
    ],
    async () => {
      return checkHouseholdMembersHaveSignedConsent(householdMembers);
    },
    {
      enabled: Boolean(householdMembers?.length),
    },
  );
};

export default useHaveAllHouseholdMembersSignedConsentQuery;
